/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  Box, Button, Container, Divider, Grid, IconButton, LinearProgress, Skeleton, TextField,
} from '@mui/material';
import {
  AccessTimeOutlined, CloseRounded, ControlPointRounded, DeleteOutlineRounded,
} from '@mui/icons-material';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import { getSubscriptions, updateSubscriptions } from '../../../../Redux/Models/subscription';
import { formatNumToCurrency } from '../../../../Utils/helpers';
import { IconEdit, IconTrash } from '../../../../Assets/Icons';
import Addons from '../Addons';
import Images from '../../../../Configs/images';
import ConfirmationContext from '../../../../Context/ConfirmationContext';

export default function Component({
  data, classes, error, message, isLoading, updated,
  isLoadingUpdate,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { openAlert } = useContext(AlertContext);
  const { openConfirmation, closeConfirmation } = useContext(ConfirmationContext);

  const [selectedSub, setSub] = useState({});
  const [prepareEdit, setPrepareEdit] = useState({});

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  useEffect(() => {
    if (updated) {
      openAlert({
        message: 'Subscription has updated',
        severity: 'success',
      });

      setPrepareEdit({});
      dispatch(getSubscriptions());
    }
  }, [updated]);

  useEffect(() => {
    dispatch(getSubscriptions());
  }, []);

  const handleDeleteSub = (subId) => {
    openConfirmation({
      handleAgree: () => closeConfirmation(),
      handleClose: () => {},
      title: 'Delete Package',
      desc: 'To delete this package please input password first. Your progress cannot be undone!',
      confirmText: 'Cancel',
      cancelText: 'Yes, Delete',
      direction: 'row-reverse',
      btnTextSize: '14px',
      maxWidth: 'xs',
    });
  };

  const prepareForEdit = (sub) => {
    setPrepareEdit(JSON.parse(sub));
  };

  const handleChangeBenefit = (newVal, index) => {
    const newArr = prepareEdit.package_benefit || [];
    newArr[index] = newVal;

    setPrepareEdit({
      ...prepareEdit,
      package_benefit: newArr,
    });
  };

  const addBenefit = () => {
    const newArr = prepareEdit.package_benefit || [];
    newArr.push('');
    setPrepareEdit({
      ...prepareEdit,
      package_benefit: newArr,
    });
  };

  const removeBenefit = (index) => {
    const newArr = prepareEdit.package_benefit || [];
    newArr.splice(index, 1);
    setPrepareEdit({
      ...prepareEdit,
      package_benefit: newArr,
    });
  };

  const handleChangeTnC = (newVal, index) => {
    const newArr = prepareEdit.terms_and_conditions || [];
    newArr[index] = newVal;

    setPrepareEdit({
      ...prepareEdit,
      terms_and_conditions: newArr,
    });
  };

  const addTnC = () => {
    const newArr = prepareEdit.terms_and_conditions || [];
    newArr.push('');
    setPrepareEdit({
      ...prepareEdit,
      terms_and_conditions: newArr,
    });
  };

  const removeTnC = (index) => {
    const newArr = prepareEdit.terms_and_conditions || [];
    newArr.splice(index, 1);
    setPrepareEdit({
      ...prepareEdit,
      terms_and_conditions: newArr,
    });
  };

  const handleSaveData = () => {
    if (prepareEdit.id) {
      const body = {
        ...prepareEdit,
        subscription_id: prepareEdit.id,
      };
      dispatch(updateSubscriptions(body));
    }
  };

  const renderPackages = () => {
    if (isLoading) {
      return [1, 2].map((idx) => (
        <Grid item key={idx} xs={6}>
          <Box className="package-box mt-4" key={idx}>
            <div className="regular" />
            <div className="detail-container">
              <div className="flex gap-16 mt-2 align-items-center">
                <Skeleton variant="circular" width={42} height={42} />
                <Skeleton variant="text" width={100} height={24} />
              </div>

              <Divider sx={{ my: 2 }} />

              <Skeleton variant="text" width={100} />
              <Skeleton variant="text" width={100} />
              <Skeleton variant="text" width={100} />

              <Divider sx={{ my: 2 }} />

              <div className="flex mt-1 align-items-center space-between">
                <div className="weight-700 s-16">
                  <Skeleton variant="rectangular" className="rounded" width={120} height={24} />
                </div>
                <Skeleton variant="rectangular" className="rounded" width={100} height={32} />
              </div>
            </div>
          </Box>
        </Grid>
      ));
    }
    if (data.length) {
      return data.map((subscription) => (
        <Grid item key={subscription.id} xs={6}>
          <Box mt={3} className={classes.packageBox}>
            <div className="regular" />
            <div className="detail-container">
              <div className="flex gap-16 mt-2 align-items-center">
                <img alt="star" src={subscription.images[0]} width="42" height="42" className="circle" />
                <div className="weight-700 s-16">{subscription.name}</div>
              </div>

              <Divider sx={{ my: 2 }} />

              {subscription.package_benefit?.map((benefit) => (
                <li className="mt-1" key={benefit}>{benefit}</li>
              ))}

              <Divider sx={{ my: 2 }} />

              <div className="flex mt-1 align-items-center space-between">
                <div className="weight-700 s-16">
                  {formatNumToCurrency(Number(subscription.price?.unit_amount) / 100)}
                  /month
                </div>
                <Button className="btn-outlined" onClick={() => setSub(subscription)}>Know More</Button>
              </div>
            </div>

            <Box display="flex" alignItems="center" justifyContent="flex-end" gap={2} mt={3} mr={2} mb={2}>
              {/* <Box display="flex"
              alignItems="center" gap={1}
              color="#004C3B" fontSize={12}
              fontWeight="600" className="link" onClick={() => handleDeleteSub(subscription.id)}>
                <IconTrash iconcolor="#004C3B" sx={{ fontSize: 20 }} />
                Delete
              </Box> */}
              <Box display="flex" alignItems="center" gap={1} color="#004C3B" fontSize={12} fontWeight="600" className="link" onClick={() => prepareForEdit(JSON.stringify(subscription))}>
                <IconEdit iconcolor="#004C3B" sx={{ fontSize: 20 }} />
                Edit
              </Box>
            </Box>
          </Box>
        </Grid>
      ));
    }

    return null;
  };

  return (
    <Elements.AdminPageBase navigate={navigate}>
      <div className={classes.root}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box fontSize={20}>
            <strong>Subscription Settings</strong>
          </Box>
        </Box>

        {isLoading && <LinearProgress color="inherit" sx={{ mt: 2 }} />}

        <Container maxWidth="md">
          <Box bgcolor="#FDFDFD" borderRadius="10px" p={2} mt={3}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box>
                <strong>OenoBank Package</strong>
                <Box fontSize={12} className="mute" mt={1}>
                  Available
                  {' '}
                  {data.length}
                  {' '}
                  packages
                </Box>
              </Box>
              {/* <Box>
                <Button startIcon={<ControlPointRounded />}
                className="btn-outlined" variant="outlined">Add New</Button>
              </Box> */}
            </Box>

            <Grid container spacing={2}>
              {renderPackages()}
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Addons />
          </Box>
        </Container>
        <Elements.ModalBase maxWidth="sm" fullWidth open={!!selectedSub.id} noAgree noCancel handleClose={() => setSub({})}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box fontWeight="700" fontSize={16}>
              Personal Package
            </Box>
            <IconButton sx={{ p: 0 }} onClick={() => setSub({})}>
              <CloseRounded fontSize="small" />
            </IconButton>
          </Box>

          <Box mt={2} className={classes.packageBox}>
            <div className="regular" />
            <div className="detail-container">
              <div className="flex align-items-center">
                {/* <img alt="star" src={subsType === 'premium'
                ? Images.PremiumStar : Images.NormalStar} /> */}
                <div className="s-16 weight-700">
                  {selectedSub.name}
                </div>
              </div>

              <Box display="flex" alignItems="center" justifyContent="space-between" mt={3}>
                <Box display="flex" alignItems="center" gap={1}>
                  <AccessTimeOutlined fontSize="small" />
                  <div className="s-14 weight-700">
                    1 Month duration
                  </div>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <img src={Images.Euro} alt="euro" width="20" />
                  <div className="s-14 weight-700">
                    {formatNumToCurrency(Number(selectedSub.price?.unit_amount) / 100)}
                  </div>
                </Box>
              </Box>

              {/* <div className="s-12 mute mt-3">Package details</div> */}
              <div className="mt-3 height-16 s-14">
                {selectedSub.description}
              </div>

              <Divider sx={{ my: 2 }} />

              <div className="s-14 weight-600">Package benefits</div>
              <div>
                {selectedSub.package_benefit?.map((benefit) => (
                  <li className="mt-2 s-14 weight-400" key={benefit}>{benefit}</li>
                ))}
              </div>

              <Divider sx={{ my: 2 }} />

              <div className="s-14 weight-600">Terms and conditions</div>
              <div>
                {selectedSub.terms_and_conditions?.map((condition) => (
                  <li className="mt-2 s-14 weight-400" key={condition}>{condition}</li>
                ))}
              </div>

            </div>
          </Box>
        </Elements.ModalBase>
        <Elements.ModalBase
          maxWidth="sm"
          fullWidth
          open={!!prepareEdit.id}
          handleClose={() => setPrepareEdit({})}
          confirmText="Save"
          handleAgree={handleSaveData}
          isLoading={isLoadingUpdate}
        >
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box fontWeight="700" fontSize={16}>
              Personal Package
            </Box>
            <IconButton sx={{ p: 0 }} onClick={() => setPrepareEdit({})}>
              <CloseRounded fontSize="small" />
            </IconButton>
          </Box>

          <Box mt={2} className={classes.packageBox}>
            <div className="regular" />
            <div className="detail-container">
              <div className="flex align-items-center">
                {/* <img alt="star" src={subsType === 'premium'
                ? Images.PremiumStar : Images.NormalStar} /> */}
                <div className="s-16 weight-700">
                  {prepareEdit.name}
                </div>
              </div>

              <Box display="flex" alignItems="center" justifyContent="space-between" mt={3}>
                <Box display="flex" alignItems="center" gap={1}>
                  <AccessTimeOutlined fontSize="small" />
                  <div className="s-14 weight-700">
                    1 Month duration
                  </div>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <img src={Images.Euro} alt="euro" width="20" />
                  <div className="s-14 weight-700">
                    {formatNumToCurrency(Number(prepareEdit.price?.unit_amount) / 100)}
                  </div>
                </Box>
              </Box>

              {/* <div className="s-12 mute mt-3">Package details</div> */}
              <div className="mt-3 height-16 s-14">
                Description
                <TextField
                  size="small"
                  value={prepareEdit.description}
                  onChange={({ target }) => setPrepareEdit({ ...prepareEdit, description: target.value })}
                  fullWidth
                />
              </div>

              <Divider sx={{ my: 2 }} />

              <div className="s-14 weight-600">Package benefits</div>
              <div>
                {new Array(prepareEdit.package_benefit?.length || 0).fill(null).map((ev, index) => (
                  <Box key={index} display="flex" alignItems="center" gap={1}>
                    <TextField
                      size="small"
                      value={prepareEdit.package_benefit[index]}
                      onChange={({ target }) => handleChangeBenefit(target.value, index)}
                      fullWidth
                    />
                    {prepareEdit.package_benefit?.length > 1
                    && (
                    <IconButton sx={{ p: 0 }} onClick={() => removeBenefit(index)}>
                      <DeleteOutlineRounded />
                    </IconButton>
                    )}
                  </Box>
                ))}
                <Button onClick={addBenefit} fullWidth size="small" variant="contained" className="btn-contained" sx={{ mt: 0.5 }}>Add More</Button>
              </div>

              <Divider sx={{ my: 2 }} />

              <div className="s-14 weight-600">Terms and conditions</div>
              <div>
                {new Array(prepareEdit.terms_and_conditions?.length || 0).fill(null).map((ev, index) => (
                  <Box key={index} display="flex" alignItems="center" gap={1}>
                    <TextField
                      size="small"
                      value={prepareEdit.terms_and_conditions[index]}
                      onChange={({ target }) => handleChangeTnC(target.value, index)}
                      fullWidth
                    />
                    {prepareEdit.terms_and_conditions?.length > 1
                    && (
                    <IconButton sx={{ p: 0 }} onClick={() => removeTnC(index)}>
                      <DeleteOutlineRounded />
                    </IconButton>
                    )}
                  </Box>
                ))}
                <Button onClick={addTnC} fullWidth size="small" variant="contained" className="btn-contained" sx={{ mt: 0.5 }}>Add More</Button>
              </div>

            </div>
          </Box>
        </Elements.ModalBase>
      </div>
    </Elements.AdminPageBase>
  );
}
